module.exports = __webpack_public_path__ + "img/Efficiency.65d0db54.jpg";